import { Button, Divider, Icons, Modal, ModalClose, ModalDialog, Stack, Typography } from '@healthinal/ui';
import { CaseClosureChecklistDto } from '../../../../api/generated/model';
import { useGetCaseClosureChecklist } from '../../../../api/generated/patient-controller/patient-controller.ts';

const { CheckCircleOutline, Cancel } = Icons;

interface ChecklistItem {
  label: string;
  passes: boolean;
}

function buildChecklist(checklist: CaseClosureChecklistDto): ChecklistItem[] {
  return [
    { label: 'Therapie', passes: checklist.therapyCompleted === true },
    { label: 'Ergänzungsmeldung', passes: checklist.supplementaryReportAvailable === true },
    { label: 'Umgebungsuntersuchung', passes: checklist.contactTracingCompleted === true },
    { label: 'DOT', passes: checklist.dotCompleted === true },
  ];
}

export function CaseClosureChecklistDialog({
  patientId,
  open,
  onClose,
  onConfirm,
}: {
  patientId: string;
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}) {
  const { data: checklist, isLoading } = useGetCaseClosureChecklist(patientId, {
    query: { enabled: open },
  });

  const items = checklist ? buildChecklist(checklist) : null;
  const allPassed = items?.every((item) => item.passes) ?? false;

  return (
    <Modal open={open} onClose={onClose}>
      <ModalDialog sx={{ width: 480 }}>
        <ModalClose />
        <Typography level={'h4'}>Fall abschliessen</Typography>
        <Divider />
        <Stack gap={2}>
          <Typography level={'body-sm'}>
            Um den Fall abzuschliessen müssen folgende Bedingungen erfüllt sein:
          </Typography>
          {isLoading && (
            <Typography level={'body-sm'}>Wird geladen...</Typography>
          )}
          {items && (
            <Stack gap={1}>
              {items.map((item) => (
                <Stack key={item.label} direction={'row'} alignItems={'center'} gap={1}>
                  {item.passes ? (
                    <CheckCircleOutline color="success" />
                  ) : (
                    <Cancel color="error" />
                  )}
                  <Typography level={'body-md'}>{item.label}</Typography>
                </Stack>
              ))}
            </Stack>
          )}
          <Stack direction={'row'} justifyContent={'space-between'}>
            <Button variant={'outlined'} onClick={onClose}>
              Abbrechen
            </Button>
            <Button disabled={!allPassed} onClick={onConfirm}>
              Bestätigen
            </Button>
          </Stack>
        </Stack>
      </ModalDialog>
    </Modal>
  );
}
